import request from "superagent";
import { getErrorMessage } from "../../utils/errors";
import { getAuthHeader } from "../../utils/superagent";

const handleError = (error) => ({
  body: {
    error: getErrorMessage(error),
  },
});

const syncFirebaseUser = async (userId) => {
  const { body } = await request
    .post(`${global.api}/agentProfile/firebase`)
    .set(await getAuthHeader())
    .send({ userId })
    .catch(handleError);

  return body;
};

const saveAgentPreference = async (reqBody) => {
  return request
    .post(`${global.api}/agentProfile/preference`)
    .set(await getAuthHeader())
    .send(reqBody)
    .then(({ body }) => body);
};

export { syncFirebaseUser, saveAgentPreference };
